import type { ObjectLibraryItem } from './types';

export const OBJECT_LIBRARY: ObjectLibraryItem[] = [
  // Tables
  {
    objectType: 'TABLE',
    name: 'Round 60"',
    category: 'Tables',
    widthFt: 5,
    heightFt: 5,
    seats: 8,
    color: '#e0e0e0',
    shape: 'CIRCLE',
    isTable: true,
    canHaveChairs: true,
    config: { tableShape: 'round' },
  },
  {
    objectType: 'TABLE',
    name: 'Round 72"',
    category: 'Tables',
    widthFt: 6,
    heightFt: 6,
    seats: 10,
    color: '#e0e0e0',
    shape: 'CIRCLE',
    isTable: true,
    canHaveChairs: true,
    config: { tableShape: 'round' },
  },
  {
    objectType: 'TABLE',
    name: 'Rectangular 6ft',
    category: 'Tables',
    widthFt: 6,
    heightFt: 2.5,
    seats: 6,
    color: '#e0e0e0',
    isTable: true,
    canHaveChairs: true,
    config: { tableShape: 'rectangular' },
  },
  {
    objectType: 'TABLE',
    name: 'Rectangular 8ft',
    category: 'Tables',
    widthFt: 8,
    heightFt: 2.5,
    seats: 8,
    color: '#e0e0e0',
    isTable: true,
    canHaveChairs: true,
    config: { tableShape: 'rectangular' },
  },
  {
    objectType: 'TABLE',
    name: 'Head Table',
    category: 'Tables',
    widthFt: 12,
    heightFt: 2.5,
    seats: 14,
    color: '#c4b5fd',
    isTable: true,
    canHaveChairs: true,
    config: { tableShape: 'head' },
  },
  {
    objectType: 'COCKTAIL_TABLE',
    name: 'Cocktail/Highboy',
    category: 'Tables',
    widthFt: 2.5,
    heightFt: 2.5,
    seats: 4,
    color: '#d1d5db',
    shape: 'CIRCLE',
    isTable: true,
    canHaveChairs: true,
  },
  {
    objectType: 'SWEETHEART_TABLE',
    name: 'Sweetheart',
    category: 'Tables',
    widthFt: 4,
    heightFt: 2.5,
    seats: 2,
    color: '#fda4af',
    isTable: true,
    canHaveChairs: true,
  },
  {
    objectType: 'TABLE_SERPENTINE',
    name: 'Serpentine',
    category: 'Tables',
    widthFt: 6,
    heightFt: 6,
    seats: 5,
    color: '#e0e0e0',
    shape: 'SERPENTINE',
    isTable: true,
    canHaveChairs: true,
  },
  {
    objectType: 'TABLE_HALF_ROUND',
    name: 'Half-round',
    category: 'Tables',
    widthFt: 6,
    heightFt: 3,
    seats: 5,
    color: '#e0e0e0',
    shape: 'HALF_ROUND',
    isTable: true,
    canHaveChairs: true,
  },
  // Chairs
  {
    objectType: 'CHAIR_ROW',
    name: 'Chair Row (10)',
    category: 'Chairs',
    widthFt: 20,
    heightFt: 2,
    seats: 10,
    color: '#d1d5db',
    config: { rows: 1, seatsPerRow: 10, chairSpacingFt: 2, rowSpacingFt: 3 },
  },
  {
    objectType: 'CHAIR_ROW',
    name: 'Chair Block (5x10)',
    category: 'Chairs',
    widthFt: 20,
    heightFt: 15,
    seats: 50,
    color: '#d1d5db',
    config: { rows: 5, seatsPerRow: 10, chairSpacingFt: 2, rowSpacingFt: 3 },
  },
  {
    objectType: 'CHAIR_ROW',
    name: 'Chair Row Group',
    category: 'Chairs',
    widthFt: 16,
    heightFt: 12,
    seats: 40,
    color: '#d1d5db',
    config: { rows: 4, seatsPerRow: 10, chairSpacingFt: 2, rowSpacingFt: 3 },
  },
  // Ceremony
  {
    objectType: 'CHUPPAH',
    name: 'Chuppah',
    category: 'Ceremony',
    widthFt: 8,
    heightFt: 8,
    color: '#fef3c7',
  },
  {
    objectType: 'LECTERN',
    name: 'Lectern',
    category: 'Ceremony',
    widthFt: 2,
    heightFt: 2,
    color: '#a8a29e',
  },
  {
    objectType: 'RING_BEARER_TABLE',
    name: 'Ring Bearer Table',
    category: 'Ceremony',
    widthFt: 2,
    heightFt: 2,
    color: '#fde68a',
    shape: 'CIRCLE',
  },
  {
    objectType: 'MECHITZA',
    name: 'Mechitza',
    category: 'Ceremony',
    widthFt: 20,
    heightFt: 1,
    color: '#e5e7eb',
  },
  {
    objectType: 'AISLE',
    name: 'Aisle',
    category: 'Ceremony',
    widthFt: 3,
    heightFt: 20,
    color: '#f1f5f9',
  },
  // Catering
  {
    objectType: 'BUFFET',
    name: 'Buffet Station',
    category: 'Catering',
    widthFt: 8,
    heightFt: 3,
    color: '#bfdbfe',
  },
  {
    objectType: 'BAR',
    name: 'Bar',
    category: 'Catering',
    widthFt: 8,
    heightFt: 4,
    color: '#c7d2fe',
  },
  {
    objectType: 'DESSERT_TABLE',
    name: 'Dessert Table',
    category: 'Catering',
    widthFt: 6,
    heightFt: 3,
    color: '#fbcfe8',
  },
  // Entertainment
  {
    objectType: 'STAGE',
    name: 'Stage',
    category: 'Entertainment',
    widthFt: 16,
    heightFt: 12,
    color: '#fde68a',
  },
  {
    objectType: 'DJ_BOOTH',
    name: 'DJ Booth',
    category: 'Entertainment',
    widthFt: 6,
    heightFt: 4,
    color: '#a78bfa',
  },
  {
    objectType: 'DANCE_FLOOR',
    name: 'Dance Floor',
    category: 'Entertainment',
    widthFt: 20,
    heightFt: 20,
    color: '#e0f2fe',
  },
  {
    objectType: 'PHOTO_BOOTH',
    name: 'Photo Booth',
    category: 'Entertainment',
    widthFt: 8,
    heightFt: 8,
    color: '#ddd6fe',
  },
  // Areas
  {
    objectType: 'AREA',
    name: 'Custom Area',
    category: 'Areas',
    widthFt: 10,
    heightFt: 10,
    color: '#f0fdf4',
    isBackground: true,
  },
  // Lounge
  {
    objectType: 'SOFA',
    name: 'Sofa',
    category: 'Lounge',
    widthFt: 6,
    heightFt: 2.5,
    seats: 3,
    color: '#d6d3d1',
    shape: 'ROUNDED_RECT',
  },
  {
    objectType: 'LOVESEAT',
    name: 'Loveseat',
    category: 'Lounge',
    widthFt: 4,
    heightFt: 2.5,
    seats: 2,
    color: '#d6d3d1',
    shape: 'ROUNDED_RECT',
  },
  {
    objectType: 'ARMCHAIR',
    name: 'Armchair',
    category: 'Lounge',
    widthFt: 2.5,
    heightFt: 2.5,
    seats: 1,
    color: '#d6d3d1',
    shape: 'ROUNDED_RECT',
  },
  {
    objectType: 'OTTOMAN',
    name: 'Ottoman',
    category: 'Lounge',
    widthFt: 2,
    heightFt: 2,
    color: '#a8a29e',
    shape: 'CIRCLE',
  },
  {
    objectType: 'COFFEE_TABLE',
    name: 'Coffee Table',
    category: 'Lounge',
    widthFt: 3,
    heightFt: 1.5,
    color: '#e7e5e4',
    shape: 'RECTANGLE',
  },
  // AV/Tech
  {
    objectType: 'PROJECTOR_SCREEN',
    name: 'Projector Screen',
    category: 'AV/Tech',
    widthFt: 8,
    heightFt: 0.5,
    color: '#f8fafc',
  },
  {
    objectType: 'PODIUM',
    name: 'Podium',
    category: 'AV/Tech',
    widthFt: 2,
    heightFt: 2,
    color: '#374151',
  },
  {
    objectType: 'PIANO',
    name: 'Piano',
    category: 'AV/Tech',
    widthFt: 5,
    heightFt: 2.5,
    color: '#1f2937',
    shape: 'ROUNDED_RECT',
  },
  {
    objectType: 'SPEAKER',
    name: 'Speaker',
    category: 'AV/Tech',
    widthFt: 1,
    heightFt: 1,
    color: '#374151',
    shape: 'CIRCLE',
  },
  // Décor
  {
    objectType: 'PLANT_FLORAL',
    name: 'Plant / Floral',
    category: 'Décor',
    widthFt: 2,
    heightFt: 2,
    color: '#86efac',
    shape: 'CIRCLE',
  },
  {
    objectType: 'ARCH',
    name: 'Arch',
    category: 'Décor',
    widthFt: 8,
    heightFt: 8,
    color: '#f5f0e8',
    shape: 'DIAMOND',
  },
  {
    objectType: 'PHOTO_WALL',
    name: 'Photo Wall',
    category: 'Décor',
    widthFt: 8,
    heightFt: 3,
    color: '#fce7f3',
  },
  {
    objectType: 'PILLAR',
    name: 'Pillar',
    category: 'Décor',
    widthFt: 1.5,
    heightFt: 1.5,
    color: '#e5e7eb',
    shape: 'CIRCLE',
  },
  {
    objectType: 'CANDLE_LIGHT',
    name: 'Candle / Light',
    category: 'Décor',
    widthFt: 1,
    heightFt: 1,
    color: '#fef08a',
    shape: 'CIRCLE',
  },
  // Structure
  {
    objectType: 'PARTITION',
    name: 'Partition / Divider',
    category: 'Structure',
    widthFt: 10,
    heightFt: 0.5,
    color: '#9ca3af',
  },
  {
    objectType: 'STAIRS',
    name: 'Stairs',
    category: 'Structure',
    widthFt: 6,
    heightFt: 4,
    color: '#d1d5db',
  },
  {
    objectType: 'COLUMN',
    name: 'Column',
    category: 'Structure',
    widthFt: 1.5,
    heightFt: 1.5,
    color: '#6b7280',
    shape: 'CIRCLE',
  },
  {
    objectType: 'WALL_SEGMENT',
    name: 'Wall Segment',
    category: 'Structure',
    widthFt: 8,
    heightFt: 0.5,
    color: '#9ca3af',
  },
  // Doors
  {
    objectType: 'DOOR_OPEN_IN_RIGHT',
    name: 'Door – Open In (hinge left)',
    category: 'Structure',
    widthFt: 3,
    heightFt: 3,
    color: '#f9fafb',
    strokeColor: '#374151',
  },
  {
    objectType: 'DOOR_OPEN_IN_LEFT',
    name: 'Door – Open In (hinge right)',
    category: 'Structure',
    widthFt: 3,
    heightFt: 3,
    color: '#f9fafb',
    strokeColor: '#374151',
  },
  {
    objectType: 'DOOR_OPEN_IN_BOTH',
    name: 'Double Door – Open In',
    category: 'Structure',
    widthFt: 6,
    heightFt: 3,
    color: '#f9fafb',
    strokeColor: '#374151',
  },
  {
    objectType: 'DOOR_OPEN_OUT_RIGHT',
    name: 'Door – Open Out (hinge left)',
    category: 'Structure',
    widthFt: 3,
    heightFt: 3,
    color: '#f9fafb',
    strokeColor: '#374151',
  },
  {
    objectType: 'DOOR_OPEN_OUT_LEFT',
    name: 'Door – Open Out (hinge right)',
    category: 'Structure',
    widthFt: 3,
    heightFt: 3,
    color: '#f9fafb',
    strokeColor: '#374151',
  },
  {
    objectType: 'DOOR_OPEN_OUT_BOTH',
    name: 'Double Door – Open Out',
    category: 'Structure',
    widthFt: 6,
    heightFt: 3,
    color: '#f9fafb',
    strokeColor: '#374151',
  },
  {
    objectType: 'DOOR_SLIDING',
    name: 'Sliding Door',
    category: 'Structure',
    widthFt: 6,
    heightFt: 1,
    color: '#f9fafb',
    strokeColor: '#374151',
  },
  // Windows
  {
    objectType: 'WINDOW',
    name: 'Window',
    category: 'Structure',
    widthFt: 4,
    heightFt: 0.5,
    color: '#bfdbfe',
    strokeColor: '#374151',
  },
];
